(() => {
  const header = document.querySelector('.studio-header');
  const details = [...document.querySelectorAll('.studio-header details')];
  details.forEach(d => d.addEventListener('toggle', () => {
    if (d.open) details.forEach(other => { if (other !== d) other.open = false; });
  }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') details.forEach(d => d.open = false); });
  document.addEventListener('click', e => { if (!header?.contains(e.target)) details.forEach(d => d.open = false); });
  const hoverEnabled = () => matchMedia('(hover:hover) and (pointer:fine) and (min-width:761px)').matches;
  header?.querySelectorAll('.studio-menu').forEach(d => {
    let closing;
    const enter = () => { clearTimeout(closing); if (hoverEnabled() && !d.open) { d.dataset.openedByHover = 'true'; d.open = true; } };
    d.querySelector('summary').addEventListener('click', e => {
      if (hoverEnabled() && d.open && d.dataset.openedByHover === 'true' && !e.target.matches(':focus-visible')) {
        e.preventDefault(); d.dataset.openedByHover = 'false';
      }
    });
    const leave = () => { clearTimeout(closing); closing = setTimeout(() => {
      if (!d.matches(':hover') && !d.contains(document.activeElement)) { d.open = false; d.dataset.openedByHover = 'false'; }
    }, 240); };
    d.addEventListener('pointerenter', enter);
    d.addEventListener('pointerleave', leave);
    d.querySelector('.studio-mega')?.addEventListener('pointerenter', enter);
    d.querySelector('.studio-mega')?.addEventListener('pointerleave', leave);
    d.addEventListener('focusout', leave);
  });
  const root = document.querySelector('[data-studio-home]');
  if (!root || root.dataset.carouselReady === 'true') return;
  root.dataset.carouselReady = 'true';
  const rail = root.querySelector('[data-studio-slides]');
  const originals = [...rail.children];
  const count = originals.length;
  if (count < 2) return;
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  let reduced = media.matches;
  const en = document.documentElement.lang === 'en';
  const clone = node => {
    const copy = node.cloneNode(true);
    copy.dataset.carouselClone = 'true';
    copy.setAttribute('aria-hidden', 'true');
    copy.inert = true;
    return copy;
  };
  rail.prepend(clone(originals[count - 1]));
  rail.append(clone(originals[0]));
  let index = 0, busy = false, normalizing = false, settleTimer, autoTimer;
  let paused = false, interacting = false, hoveredControl = false;
  const toggle = root.querySelector('[data-autoplay-toggle]');
  const status = root.querySelector('[data-slide-status]');
  const interval = Math.max(3000, Number(root.dataset.autoplayInterval) || 7000);
  const clearAuto = () => { clearTimeout(autoTimer); autoTimer = null; };
  const allowed = () => !reduced && !paused && !interacting && !hoveredControl && !document.hidden && (!root.contains(document.activeElement) || document.activeElement === toggle);
  const syncToggle = () => {
    toggle.hidden = reduced;
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? (en ? 'Play carousel' : 'Reanudar carrusel') : (en ? 'Pause carousel' : 'Pausar carrusel'));
    toggle.innerHTML = paused ? '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M7 4l13 8-13 8z"/></svg>' : '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M8 4v16M16 4v16"/></svg>';
  };
  const update = n => {
    index = (n + count) % count;
    const slide = originals[index];
    root.querySelector('h1').textContent = 'THINKCAR ' + slide.dataset.model;
    root.querySelector('.studio-sub').textContent = slide.dataset.subtitle;
    root.querySelectorAll('[data-slide-dot]').forEach((b, i) => {
      if (i === index) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    status.textContent = slide.dataset.model + ' · ' + (index + 1) + ' / ' + count;
    root.dataset.carouselIndex = String(index);
  };
  const jump = position => {
    normalizing = true;
    rail.style.scrollSnapType = 'none';
    rail.scrollTo({ left: position * rail.clientWidth, behavior: 'instant' });
    requestAnimationFrame(() => { rail.style.scrollSnapType = ''; normalizing = false; });
  };
  const schedule = () => { clearAuto(); if (allowed() && !busy) autoTimer = setTimeout(() => go(index + 1, true), interval); };
  const settle = () => {
    clearTimeout(settleTimer);
    if (normalizing) return;
    const position = Math.round(rail.scrollLeft / rail.clientWidth);
    if (Math.abs(rail.scrollLeft - position * rail.clientWidth) > 2) return;
    update(position - 1);
    if (position === 0) jump(count);
    else if (position === count + 1) jump(1);
    busy = false;
    schedule();
  };
  const go = (target, auto = false) => {
    if (reduced) {
      clearAuto(); clearTimeout(settleTimer);
      status.setAttribute('aria-live', 'polite');
      update(target); busy = false; jump(index + 1);
      return;
    }
    if (busy) return;
    clearAuto();
    let position = target + 1;
    if (target === 0 && index === count - 1) position = count + 1;
    if (target === count - 1 && index === 0) position = 0;
    status.setAttribute('aria-live', auto ? 'off' : 'polite');
    update(target);
    busy = true;
    rail.scrollTo({ left: position * rail.clientWidth, behavior: reduced ? 'instant' : 'smooth' });
    clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, reduced ? 40 : 850);
  };
  rail.addEventListener('scroll', () => {
    if (normalizing) return;
    clearAuto(); clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, 140);
  }, { passive: true });
  rail.addEventListener('scrollend', settle);
  root.querySelector('[data-slide-next]').onclick = () => go(index + 1);
  root.querySelector('[data-slide-prev]').onclick = () => go(index - 1);
  root.querySelectorAll('[data-slide-dot]').forEach(b => b.onclick = () => go(Number(b.dataset.slideDot)));
  rail.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1)); }
  });
  toggle.onclick = () => { paused = !paused; syncToggle(); schedule(); };
  root.addEventListener('focusin', clearAuto);
  root.addEventListener('focusout', () => setTimeout(schedule, 0));
  root.addEventListener('pointerover', e => { const control = e.target.closest('a,button'); if (control && control !== toggle) { hoveredControl = true; clearAuto(); } });
  root.addEventListener('pointerout', e => { if (!e.relatedTarget?.closest?.('a,button') || e.relatedTarget?.closest?.('a,button') === toggle) { hoveredControl = false; schedule(); } });
  rail.addEventListener('pointerdown', () => { interacting = true; clearAuto(); });
  document.addEventListener('pointerup', () => { interacting = false; schedule(); });
  document.addEventListener('visibilitychange', schedule);
  media.addEventListener('change', e => { reduced = e.matches; syncToggle(); schedule(); });
  new ResizeObserver(() => { if (!busy) jump(index + 1); }).observe(rail);
  update(0); jump(1); syncToggle(); schedule();
  window.PCP_STUDIO_CAROUSEL = { root, get index() { return index; }, get count() { return count; }, get interval() { return interval; } };

})();
